module.exports = __webpack_public_path__ + "img/faqs_layout2.dc971a03.png";